import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

/**
 * Barthel Index.
 */
export const BARTHEL_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.BARTHEL_SCALE,
  title: 'Barthel Index',
  scoreConfig: {
    scoreKey: 'totale',
    scoreFields: [
      'alimentazione',
      'bagno',
      'igiene_personale',
      'vestizione',
      'vescica',
      'intestino',
      'wc',
      'trasferimenti',
      'mobilita',
      'scale',
    ],
  },
  sections: [
    {
      name: 'barthel',
      label: 'Barthel Index',
      fields: [
        // 1) ALIMENTAZIONE
        {
          key: 'alimentazione',
          label: 'Alimentazione',
          type: 'number',
          min: 0,
          max: 10,
          step: 5,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Dipendente.',
            '5': 'Necessita aiuto per preparare o tagliare il cibo.',
            '10': 'Indipendente.',
          },
          description: 'Capacità di nutrirsi in autonomia.',
        },
        // 2) BAGNO
        {
          key: 'bagno',
          label: 'Bagno',
          type: 'number',
          min: 0,
          max: 5,
          step: 5,
          maxScore: 5,
          valueDescriptions: {
            '0': 'Dipendente.',
            '5': 'Indipendente.',
          },
          description: 'Capacità di fare il bagno o la doccia.',
        },
        // 3) IGIENE PERSONALE
        {
          key: 'igiene_personale',
          label: "Cura dell'igiene personale",
          type: 'number',
          min: 0,
          max: 5,
          step: 5,
          maxScore: 5,
          valueDescriptions: {
            '0': 'Dipendente.',
            '5': 'Indipendente.',
          },
          description: 'Lavarsi il viso, pettinarsi, lavarsi i denti.',
        },

        // 4) VESTIZIONE
        {
          key: 'vestizione',
          label: 'Vestizione',
          type: 'number',
          min: 0,
          max: 10,
          step: 5,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Dipendente.',
            '5': 'Necessita di aiuto.',
            '10': 'Indipendente.',
          },
          description: 'Capacità di vestirsi e svestirsi.',
        },

        // 5) CONTROLLO VESCICA
        {
          key: 'vescica',
          label: 'Controllo della vescica',
          type: 'number',
          min: 0,
          max: 10,
          step: 5,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Incontinenza.',
            '5': 'Occasionali perdite.',
            '10': 'Continenza completa.',
          },
          description: 'Gestione della continenza urinaria.',
        },
        // 6) CONTROLLO INTESTINO
        {
          key: 'intestino',
          label: 'Controllo dell’intestino',
          type: 'number',
          min: 0,
          max: 10,
          step: 5,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Incontinenza.',
            '5': 'Occasionali episodi.',
            '10': 'Continenza completa.',
          },
          description: 'Gestione della continenza fecale.',
        },
        // 7) USO DEL WC
        {
          key: 'wc',
          label: 'Uso del WC',
          type: 'number',
          min: 0,
          max: 10,
          step: 5,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Dipendente.',
            '5': 'Necessita aiuto.',
            '10': 'Indipendente.',
          },
          description: 'Usare il WC, igiene e gestione abbigliamento.',
        },

        // 8) TRASFERIMENTI LETTO/SEDIA
        {
          key: 'trasferimenti',
          label: 'Trasferimenti letto/sedia',
          type: 'number',
          min: 0,
          max: 15,
          step: 5,
          maxScore: 15,
          valueDescriptions: {
            '0': 'Dipendente.',
            '5': 'Forte aiuto fisico.',
            '10': 'Aiuto minimo / supervisione.',
            '15': 'Indipendente.',
          },
          description: 'Alzarsi dal letto e sedersi sulla sedia.',
        },

        // 9) MOBILITÀ
        {
          key: 'mobilita',
          label: 'Mobilità (cammino/carrozzina)',
          type: 'number',
          min: 0,
          max: 15,
          step: 5,
          maxScore: 15,
          valueDescriptions: {
            '0': 'Immobile.',
            '5': 'Carrozzina indipendente 50 metri.',
            '10': 'Cammina con aiuto 50 metri.',
            '15': 'Cammina indipendentemente 50 metri.',
          },
          description: 'Camminare o muoversi in carrozzina.',
        },
        // 10) SCALE
        {
          key: 'scale',
          label: 'Salire e scendere le scale',
          type: 'number',
          min: 0,
          max: 10,
          step: 5,
          maxScore: 10,
          valueDescriptions: {
            '0': 'Incapace.',
            '5': 'Aiuto fisico o supervisione.',
            '10': 'Indipendente.',
          },
          description: 'Capacità di affrontare una rampa di scale.',
        },
      ],
    },
  ],
  computedFields: [
    // TOTALE
    {
      key: 'totale',
      label: 'Punteggio totale',
      type: 'number',
      calculation: 'SUM(scoreConfig.sumOf)',
      maxScore: 100,
    },
    // INTERPRETAZIONE AUTOMATICA
    {
      key: 'interpretazione',
      label: 'Interpretazione del livello di dipendenza',
      type: 'text',
      calculation: `
        IF(totale >= 100, "Indipendenza totale",
          IF(totale >= 75, "Dipendenza lieve",
            IF(totale >= 50, "Dipendenza moderata",
              IF(totale >= 25, "Dipendenza severa",
                "Dipendenza totale" 
              )
            )
          )
        )
      `,
      maxScore: 0,
    },
  ],
};
